import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import axios from 'axios'

const getErrorMessage = (error, fallbackMsg) => {
  return error.response?.data?.message || error.message || fallbackMsg;
};

export const fetchSalaries = createAsyncThunk(
  "salary/fetchSalaries",
  async (params, thunkAPI) => {
    try {

      if (!params.superAdminId) {
        return thunkAPI.rejectWithValue("SuperAdmin ID not found in local storage.");
      }

      const res = await axios.get(`https://payyug.in/api/salary-structures`, {
        params
      });

      return res.data?.data || null;
    } catch (error) {
      const errorMsg = getErrorMessage(error, "Failed to fetch employee salary.");
      return thunkAPI.rejectWithValue(errorMsg);
    }
  }
);

const salarySlice = createSlice({
  name: "salary",
  initialState: {
    salaryData: null,
    loading: false,
    error: null,
  },
  reducers: {
    // Synchronous reducers can be added here if needed
    clearSalaryState: (state) => {
      state.salaryData = null;
      state.loading = false;
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSalaries.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSalaries.fulfilled, (state, action) => {
        state.loading = false;
        state.salaryData = action.payload;
      })
      .addCase(fetchSalaries.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export const { clearSalaryState } = salarySlice.actions;
export default salarySlice.reducer;